import { combineReducers } from 'redux'

// import stuff from './stuff'

export default combineReducers({
  // stuff
})
